import { Injectable } from '@angular/core';

import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';
import { MarkSpotlightAsSeenBody } from '@reach/interfaces/spotlights/spotlights.requests';
import {
	GetUnseenSpotlightsResponse,
	MarkAllAsUnseenByCurrentUserResponse,
	MarkSpotlightAsSeenResponse,
} from '@reach/interfaces/spotlights/spotlights.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class SpotlightsApiService extends BaseApiService {
	protected commonPath = ['spotlights'];

	public async getUnseenSpotlights(): Promise<GetUnseenSpotlightsResponse> {
		const params = { t: this.paramTime };

		return await this.http.get<GetUnseenSpotlightsResponse>(this.url(''), params);
	}

	public async markSpotlightsAsSeen(
		spotlightIds: SpotlightKey[]
	): Promise<MarkSpotlightAsSeenResponse> {
		const dto: MarkSpotlightAsSeenBody = { spotlightIds };

		return await this.http.post<MarkSpotlightAsSeenResponse>(this.url(''), dto);
	}

	public async markAllAsUnseenByUser(): Promise<MarkAllAsUnseenByCurrentUserResponse> {
		return await this.http.post<MarkAllAsUnseenByCurrentUserResponse>(
			this.url('admin', 'all-unseen-by-user')
		);
	}
}
